import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { jwtDecode, JwtPayload } from 'jwt-decode';
import { HourFormatService } from './aplication/api/Infra/HourFormat.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private _hourFormatService: HourFormatService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    const token = localStorage.getItem('authTokenLicitaAdmin');
    const isLoginPage = next.data['isLoginPage'];

    if (isLoginPage && token) {
      // Se o usuário já estiver autenticado e tentar acessar a tela de login, redirecione para a página principal
      this.router.navigate(['/licita/users']);
      return false;
    }

    if (!token && !isLoginPage) {
      // Se não houver token e não for a página de login, redirecione para o login
      this.router.navigate(['/login']);
      return false;
    }

    if (token && !isLoginPage) {
      try {
        const decodedToken = jwtDecode<CustomJwtPayload>(token);
        const isTokenExpired = decodedToken.exp ? decodedToken.exp * 1000 < Date.now() : true;

        if (isTokenExpired) {
          localStorage.removeItem('authTokenLicitaAdmin');
          this.router.navigate(['/login']);
          return false;
        }

        const allowedRoles = next.data['allowedRoles'];
        if (allowedRoles && Array.isArray(allowedRoles)) {
          if (!allowedRoles.includes(decodedToken.role)) {
            this.router.navigate(['/licita/users']);
            return false;
          }
        }

        return true;
      } catch (error) {
        console.error('Erro ao decodificar token:', error);
        localStorage.removeItem('authTokenLicitaAdmin');
        this.router.navigate(['/login']);
        return false;
      }
    }

    return true;
  }
}

export interface CustomJwtPayload extends JwtPayload {
  role?: string;
}